import { navLinks } from '@/mocks/homeData';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="mx-auto grid grid-cols-1 gap-10 px-4 py-14 md:grid-cols-4 md:px-10 md:py-16">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
              瓜
            </span>
            <span className="font-heading text-xl font-bold text-background-50">美日吃瓜</span>
          </div>
          <p className="mt-5 max-w-md text-sm leading-7 text-background-200">
            汇集美日两国社会奇闻与奇葩事件，离奇案件、迷惑行为、都市怪谈、民间传说持续收录。
            把「发生了什么」和「大家怎么说」分开写清楚，带你见识大千世界的无奇不有。
          </p>
          <p className="mt-5 inline-flex items-center gap-2 rounded-md bg-secondary-800 px-3 py-2 text-xs text-background-200">
            <i className="ri-mail-line"></i>
            投稿与联络：hello@meirichigua.com
          </p>
        </div>

        <div>
          <h4 className="font-heading text-base font-semibold text-background-50">
            <a href="#categories" className="transition-colors hover:text-accent-300">栏目导航</a>
          </h4>
          <ul className="mt-5 space-y-3 text-sm">
            {navLinks.map((link) => (
              <li key={link.id}>
                <a href={`#${link.id}`} className="text-background-200 transition-colors hover:text-accent-300">
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-base font-semibold text-background-50">
            <a href="#faq" className="transition-colors hover:text-accent-300">内容原则</a>
          </h4>
          <ul className="mt-5 space-y-3 text-sm text-background-200">
            <li className="flex items-start gap-2">
              <i className="ri-shield-check-line mt-0.5 text-accent-400"></i>
              标注来源，区分事实与传闻
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-user-3-line mt-0.5 text-accent-400"></i>
              保护当事人隐私与化名处理
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-refresh-line mt-0.5 text-accent-400"></i>
              存疑内容持续回访更新
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-forbid-2-line mt-0.5 text-accent-400"></i>
              拒绝编造与恶意消费悲剧
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-100/15">
        <div className="mx-auto flex flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-background-300 sm:flex-row md:px-10">
          <p>© {year} 美日吃瓜 · 内容仅供阅读与讨论，部分故事无法完全核实，请理性看待。</p>
          <p className="flex items-center gap-4">
            <a href="#about" className="transition-colors hover:text-accent-300">关于我们</a>
            <a href="#faq" className="transition-colors hover:text-accent-300">常见问题</a>
            <a href="#subscription" className="transition-colors hover:text-accent-300">订阅更新</a>
          </p>
        </div>
      </div>
    </footer>
  );
}